// extracted by mini-css-extract-plugin
module.exports = {"container":"RegnskogSection_container__ls2sw","link":"RegnskogSection_link__3FweR"};